export default {"src":"/_next/static/media/section2.193d6e1b.svg","height":307,"width":499,"blurWidth":0,"blurHeight":0};